import "@/common/jquery.js";
import { axiosConfig } from '@/config/config';

function ajax2(uoptions) {

    function aaaa() {
        return this;
    }

    var insideOptions = {};

    for (var i in uoptions) {
        if (i == "success") {
            continue
        }
        if (i == "error") {
            continue
        }
        insideOptions[i] = uoptions[i]
    }

    insideOptions.url = axiosConfig.baseUrl + uoptions.url;
    insideOptions.type = "post";
    insideOptions.dataType = "json";
    insideOptions.timeout = insideOptions.timeout;

    return $.ajax({
        ...insideOptions,
        success: (res) => {
            uoptions.success && uoptions.success(res);
            if (res.code == 406) {
                this.$store && this.$store.commit("logout")
            }
        },
        error: (res) => {
            uoptions.error && uoptions.error(res)
        }
    })
}

export default ajax2;


// WEBPACK FOOTER //
// ./src/common/jqajax.js